import { z } from '@harvestiq/zod';

export const smsSubscribeUserNotFoundDataSchema = z.object({
  phoneNumber: z.string(),
});

export type SmsSubscribeUserNotFoundData = z.infer<
  typeof smsSubscribeUserNotFoundDataSchema
>;
